import React, { useMemo, useState, useEffect } from "react";
import loadding from "asset/img/loadding.webp";
import { ossImageCompress, OssOther } from "utils/const.js";
import PetAvatar from "components/PetAvatar";
import "./index.scss";

const FIRST_LOGIN_TIPS = [
  {
    main: "AI 正在扫描小朋友右脑语言黄金期…",
    sub: " 智能捕捉黄金期：右脑听力敏感期 / 图像化复述爆发点  ",
  },
  {
    main: "AI 生成右脑专属语言训练路线…",
    sub: " 算法配方出炉：每日 10 分钟右脑激活 × 情境化闯关",
  },
  // {
  //   main: "AI 生成右脑专属关卡地图…",
  //   sub: " 加载中：右脑启蒙第一关就位，用图像 + 韵律开启冒险～",
  // },
];

const Loadding = ({
  visible = true,
  variant = "default", // default | first_login
}) => {
  const [animated, setAnimated] = useState(false);
  const [tipIndex, setTipIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const isFirstLogin = variant === "first_login";
  const tips = useMemo(
    () => (isFirstLogin ? FIRST_LOGIN_TIPS : null),
    [isFirstLogin],
  );

  useEffect(() => {
    if (!visible || !isFirstLogin) return;
    setTipIndex(0);
    const duration = 2800; // 单张卡片 2.8s
    const timer = setInterval(() => {
      setTipIndex((i) => {
        if (i >= FIRST_LOGIN_TIPS.length - 1) return i; // 最后一张停住
        return i + 1;
      });
    }, duration);
    return () => clearInterval(timer);
  }, [visible, isFirstLogin]);

  const cls = `animated-img ${animated ? "animation" : ""}`;

  return (
    <>
      {visible ? (
        <div className="loadding-con">
          <div className="loadding-content">
            <div className="background">
              <img
                src={ossImageCompress(`${OssOther}/image/loadding.jpg`, 600)}
                alt=""
              />
            </div>
            <div className="avator">
              <div className={cls}>
                <PetAvatar className="loading-pet-avatar" />
              </div>

              {!isFirstLogin ? (
                <div className="font">
                  悟空正在努力加载
                  <span className="dots">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                  </span>
                </div>
              ) : (
                <div className="font font--first-login">
                  <div key={tipIndex} className="first-login-tip">
                    <div className="first-login-main">
                      {tips?.[tipIndex]?.main}
                    </div>
                    <div className="first-login-sub">
                      {tips?.[tipIndex]?.sub}
                    </div>
                    <div className="first-login-progress">
                      <div className="first-login-progress-bar" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Loadding;
